import { Builder } from '@builder.io/react';
import AliBanatLegacy from '../../../../../pages/home/components/aliBanatLegacy';

function aliBannatLegacy() {
  return (
    <AliBanatLegacy />
  )
}

export default aliBannatLegacy

Builder.registerComponent(aliBannatLegacy, {
  name: 'AliBannatLegacy',
  
});